module.exports = __webpack_public_path__ + "img/8A7968_3C342D_C6B3A5_54443B-256px.e5849adc.png";